import Text from '@sats-group/fresh-fitness-ui-lib/react/text';
import React from 'react';

import ContentContainer from 'root/client/components/content-container/content-container';
import SalesLoader from 'root/client/components/sales-loader/sales-loader';
import SalesLayout from 'root/client/components/sales-layout/sales-layout';

import type { CheckoutStatus as Props } from './checkout-status.types';

const CheckoutStatus: React.FunctionComponent<Props> = ({
  information,
  layout,
}) => (
  <SalesLayout {...layout}>
    <div className="checkout-status">
      <ContentContainer
        width={ContentContainer.widths.Narrow}
        className="checkout-status__content"
      >
        <div
          className="checkout-status__processing-wrapper"
          data-testid="status"
        >
          <SalesLoader />
          <Text size={Text.sizes.large}>{information}</Text>
        </div>
      </ContentContainer>
    </div>
  </SalesLayout>
);

export default CheckoutStatus;
